/* import __COLOCATED_TEMPLATE__ from './password.hbs'; */
var _class, _descriptor, _descriptor2, _descriptor3;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import { next } from '@ember/runloop';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
export let ScaPasswordError = /*#__PURE__*/function (ScaPasswordError) {
  ScaPasswordError["PASSWORD_PRESENCE"] = "PASSWORD_PRESENCE";
  ScaPasswordError["PASSWORD_TOO_SHORT"] = "PASSWORD_TOO_SHORT";
  return ScaPasswordError;
}({});
let TwoFactorScaPasswordComponent = (_class = class TwoFactorScaPasswordComponent extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "intl", _descriptor, this);
    _initializerDefineProperty(this, "password", _descriptor2, this);
    _initializerDefineProperty(this, "error", _descriptor3, this);
    _defineProperty(this, "handleInputLoaded", event => {
      next(() => event.detail.input.focus());
    });
    _defineProperty(this, "handleInputChange", event => {
      this.error = undefined;
      this.password = event.detail.value;
    });
    _defineProperty(this, "handleSubmit", event => {
      event.preventDefault();
      this.validatePassword();
      if (this.error) return;
      this.args.finish(this.password);
    });
  }
  get tPrefix() {
    return this.args.tPrefix || '';
  }
  get errorText() {
    if (!this.error) return '';
    switch (this.error) {
      case ScaPasswordError.PASSWORD_PRESENCE:
        return this.intl.t(`${this.tPrefix}two_factor_modals.sca.password.presence_error`);
      default:
        return this.intl.t(`${this.tPrefix}generic_errors.other.unknown`);
    }
  }
  validatePassword() {
    // Input hasn't been changed after last validation error. Keep the same error.
    if (this.error) return;
    if (this.password.length === 0) {
      this.error = ScaPasswordError.PASSWORD_PRESENCE;
    }
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "password", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "error", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class);
export { TwoFactorScaPasswordComponent as default };